import * as angular from "angular";

angular
  .module('triangular.components', []);
